import React from 'react';
import { CircularProgress } from '@material-ui/core';

interface LoadingScreenProp {
  loading: boolean;
}
export default function LoadingScreen({
  loading = false,
}: LoadingScreenProp) {
  return loading && (
    <div className='loading'>
      <CircularProgress />
    </div>
  );
}